import type {
  RecruitingCities_City as RecruitingCity,
  LearnerProfile_UserLocation as UserLocation,
} from '__generated__/graphql-types';

export const getLocationLabel = ({ cityName, stateName, countryName }: UserLocation) => {
  if (!cityName && !countryName && !stateName) return '';
  return [cityName, stateName, countryName].filter(Boolean).join(', ');
};

export const getLocationItem = (city: RecruitingCity, label: string) => {
  return {
    id: `${city.lat}:${city.lng}`,
    label,
    value: {
      latitude: city.lat,
      longitude: city.lng,
      label,
    },
  };
};

export const validateFullName = (name: string) => {
  const specialChars = /[!@#$%^&*()_+=[\]{};:"\\|,<>/?]+/;
  const numbers = /[0-9]/;
  const onlyUppercaseLetters = /^[A-Z| ]+$/;
  if (specialChars.test(name) || numbers.test(name) || onlyUppercaseLetters.test(name)) {
    return false;
  }
  return true;
};
